module.exports = __webpack_public_path__ + "static/media/MultipleChoice.c7d668e8.svg";